import React from 'react';
import { createRoot } from 'react-dom/client';
import TvdLiteCoverflow from './components/tvd-lite-coverflow.jsx';

import '@c0lor/ui/styles.css';
import './styles/mobile-shared.css';
import './styles/home.css';
import './styles/entry.css';
import './styles/project.css';

// The deployed demo was composed from ordered browser globals. Keep that contract
// inside one explicit bridge while Vite precompiles JSX and owns the dependency graph.
Object.assign(window, {
  React,
  ReactDOM: { createRoot },
  TvdLiteCoverflow,
  __TV_EMBED: 1,
});

const featurePromises = new Map();
const featureLoaders = {
  about: async () => {},
  db: () => import('./legacy/dbview.jsx'),
  pk: () => Promise.all([
    import('./styles/pk.css'),
    import('./legacy/pkview.jsx'),
  ]),
  agent: () => Promise.all([
    import('./styles/agent.css'),
    import('./legacy/mobile.jsx'),
    import('./legacy/agent.jsx'),
    import('./styles/pk.css'),
    import('./legacy/pkview.jsx'),
  ]),
  room: () => import('./legacy/mobile.jsx'),
  light: () => import('./legacy/mobile.jsx'),
  inspect: () => import('./legacy/mobile.jsx'),
  setup: () => import('./legacy/mobile.jsx'),
};

function loadFeature(name) {
  const loader = featureLoaders[name];
  if (!loader) return Promise.resolve();
  if (!featurePromises.has(name)) {
    featurePromises.set(name, loader().catch((error) => {
      featurePromises.delete(name);
      throw error;
    }));
  }
  return featurePromises.get(name);
}

function prefetchFeature(name) {
  void loadFeature(name).catch(() => {
    // A real click retries and reports the error; speculative warm-up stays quiet.
  });
}

window.loadFeature = loadFeature;
window.prefetchFeature = prefetchFeature;

async function bootstrap() {
  const c0lorBridge = await import('./c0lor-bridge.jsx');

  await Promise.all([
    import('./legacy/icons.jsx'),
    import('./legacy/data.jsx'),
    import('./legacy/dbdata.jsx'),
    import('./legacy/tvdprodata.jsx'),
    import('./legacy/cieloci.js'),
    import('./legacy/images.js'),
  ]);

  // Most icons now come from @c0lor/ui. The deployed page contains a handful
  // of product-specific glyphs (washer, fridge, air conditioner), kept here as
  // a narrow compatibility extension to the design system.
  c0lorBridge.installLegacyIconFallback(window.Icon);

  const initialTool = new URLSearchParams(window.location.search).get('tool');
  if (initialTool) await loadFeature(initialTool === 'compose' ? 'room' : initialTool);

  await import('./legacy/entry.jsx');
  await import('./legacy/home.jsx');
}

bootstrap().catch((error) => {
  console.error('Failed to start the TV database frontend.', error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <main class="boot-error" role="alert">
        <h1>页面加载失败</h1>
        <p>请刷新页面重试。如果问题持续出现，请检查静态资源是否完整。</p>
        <button type="button" onclick="window.location.reload()">重新加载</button>
      </main>
    `;
  }
});
